export enum WALLET_REFUND_SOURCE {
  ORIGINAL_SOURCE = "original",
  MANUAL = "manual"
}
